import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';

import { ShareResourceBannerConfig, ShareResourceStep } from './shareResourceBannerTypes';

interface ShareResourceBannerStepsProps {
  steps: readonly ShareResourceStep[];
  layout: NonNullable<ShareResourceBannerConfig['stepsLayout']>;
}

const ShareResourceBannerSteps = ({ layout, steps }: ShareResourceBannerStepsProps) => {
  const theme = useTheme();
  const isStacked = layout === 'column';

  return (
    <Box
      sx={{
        backgroundColor: theme.brandV2.colors.treadGray9,
        border: `1px solid ${theme.brandV2.colors.treadGray7}`,
        borderRadius: 2,
        display: 'flex',
        flexDirection: isStacked ? 'column' : { xs: 'column', sm: 'row' },
        overflow: 'hidden',
      }}
    >
      {steps.map(({ titleKey, subtitleKey }, index) => {
        const isFirstStep = index === 0;

        return (
          <Box
            key={titleKey}
            sx={{
              alignItems: 'flex-start',
              display: 'flex',
              flex: 1,
              gap: 1,
              p: 1.5,
              ...(isFirstStep
                ? {}
                : isStacked
                  ? { borderTop: `1px solid ${theme.brandV2.colors.treadGray7}` }
                  : {
                      borderLeft: {
                        xs: 'none',
                        sm: `1px solid ${theme.brandV2.colors.treadGray7}`,
                      },
                      borderTop: {
                        xs: `1px solid ${theme.brandV2.colors.treadGray7}`,
                        sm: 'none',
                      },
                    }),
            }}
          >
            <Box
              sx={{
                alignItems: 'center',
                backgroundColor: theme.brandV2.colors.treadGray1,
                borderRadius: '50%',
                color: theme.semantic.textInverse,
                display: 'flex',
                flexShrink: 0,
                fontSize: 11,
                fontWeight: 700,
                height: 20,
                justifyContent: 'center',
                width: 20,
              }}
            >
              {index + 1}
            </Box>
            <Box sx={{ minWidth: 0 }}>
              <Typography
                variant="body2"
                sx={{ color: theme.brandV2.colors.treadGray1, fontWeight: 600 }}
              >
                {t(titleKey)}
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: theme.brandV2.colors.treadGray2, mt: 0.25 }}
              >
                {t(subtitleKey)}
              </Typography>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default ShareResourceBannerSteps;
